import { useMutation } from '@apollo/client';

import ToggleConsolidateBillingMutation from '@/graphql/contracts/toggleConsolidateBilling.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  ToggleConsolidateBilling,
  ToggleConsolidateBillingVariables
} from '@/graphql/contracts/_generated_/toggleConsolidateBilling.mutation';
import { notificationService } from '@/services/notification/notification.client';

export default function useToggleConsolidateBilling(contractId: UUID) {

  const [_toggleConsolidateBilling, { loading, error }] =
    useMutation<ToggleConsolidateBilling, ToggleConsolidateBillingVariables>(
      ToggleConsolidateBillingMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        onCompleted: ({ toggleConsolidateBilling }) => {
          const state = toggleConsolidateBilling.consolidateBilling ? 'enabled' : 'disabled';

          notificationService.open({
            title: 'Consolidate Billing',
            text: `Consolidate Billing successfully ${state}`,
            type: 'success'
          });
        }
      }
    );

  const toggleConsolidateBilling = (consolidateBilling: ToggleConsolidateBillingVariables['consolidateBilling']) => {
    _toggleConsolidateBilling({
      variables: {
        contractId,
        consolidateBilling
      }
    });
  };

  return {
    toggleConsolidateBilling,
    isLoadingConsolidateBiling: loading,
    errorToggleConsolidateBilling: error
  } as const;
}
